import { BaseDivider } from "@/shared/ui/base-divider";
import { SidebarListItem } from "@/widgets/sidebar/ui/sidebar-list-item";
import { List } from "@mui/material";

type Props = {
  currentPath: string;
  notificationBadgeNumber: number | undefined;
  logout: () => void;
};

export const ShipperCarrierSidebar = ({
  currentPath,
  notificationBadgeNumber,
  logout,
}: Props) => {
  // TODO: shipperかつcarrierのcompanyのUXについてはは20250427現在想定されていない (サービスの思想上「利用運送」の加入は避ける運用のため)
  // TODO: 要件が出次第、デザインを考慮する必要がある
  return (
    <>
      <List>
        <SidebarListItem
          href="/notifications"
          text="お知らせ"
          icon="mail"
          isActive={currentPath === "/notifications"}
          badgeNumber={notificationBadgeNumber}
        />

        <SidebarListItem
          href="/shipper/cargos"
          text="マイ荷物"
          icon="package"
          isActive={currentPath === "/shipper/cargos"}
        />

        <SidebarListItem
          href="/carrier/cargos"
          text="荷物一覧"
          icon="search"
          isActive={currentPath === "/carrier/cargos"}
        />
      </List>

      <BaseDivider />

      <List>
        <SidebarListItem
          href="/master-data/vehicles"
          text="車両管理"
          icon="truck"
          isActive={currentPath === "/master-data/vehicles"}
        />
      </List>

      <BaseDivider />

      <List>
        <SidebarListItem
          href="#"
          text="ヘルプ"
          icon="helpCircle"
          isActive={false}
        />
        <SidebarListItem
          text="ログアウト"
          icon="logOut"
          isActive={false}
          onClick={logout}
        />
      </List>
    </>
  );
};
